.changeSelectHeader {
	margin-bottom: -2px;
}
